import React from 'react';
import { Box, Typography, TextField, Autocomplete } from '@mui/material';
import type { RoomType } from '../../../../../../services/ConfigurationService/types';

interface RoomInfoSectionProps {
  rooms: RoomType[];
  selectedRoom: RoomType | null;
  onRoomChange: (room: RoomType | null) => void;
}

export const RoomInfoSection: React.FC<RoomInfoSectionProps> = ({
  rooms,
  selectedRoom,
  onRoomChange,
}) => (
  <Box>
    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
      Room Information
    </Typography>
    <Autocomplete
      options={rooms}
      getOptionLabel={(option) => `${option.code}${option.description ? ` - ${option.description}` : ''}`}
      value={selectedRoom}
      onChange={(_, newValue) => onRoomChange(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Room"
          size="small"
          placeholder="Select a room..."
        />
      )}
    />
  </Box>
);
